import { useGetProjectsQuery } from '@/slices/projectSlice';

// its possible to filter by customer if _customer is passed

const useInvoices = ({ _customer, skip } = { _customer: '', skip: false }) => {
	const { invoices, isLoading, isError } = useGetProjectsQuery(undefined, {
		skip,
		selectFromResult: ({ data, isLoading, isError }) => {
			const invoices = data?.ids
				?.map((id) => data.entities[id]) // Map ids to project objects
				.filter((project) => project.runnerInvoice) // Filter projects with a invoice
				.filter((project) => {
					if (!_customer) return true;

					return project._customer === _customer;
				}) // Filter by customer if _customer is passed
				.map((project) => {
					return {
						...project.runnerInvoice,
						number: project.number,
						customer: project.customer,
						_project: project._id,
						type: 'invoice',
					};
				}); // Extract invoices
			return { invoices, isLoading, isError };
		},
	});

	return { invoices, isLoading, isError };
};

export default useInvoices;
